import {
  formDataToLocalizedString,
  LocalizedString,
  localizedStringToFormData,
} from '../../../../app/data/models/common/localizedString';
import MealItem from '../../../../app/data/models/mealItem';
import { LocalizedLanguageFormData } from '../../../../app/data/models/common/localizedLanguage';
export interface MenuState {
  menus: MenuData[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

export interface MenuFormProps {
  menu?: MenuFormData;
  restaurantId: string;
  cancelEdit: () => void;
}

export interface MenuFormData {
  id?: string;
  titles: LocalizedLanguageFormData;
}

export interface DeleteMenuParams {
  restaurantId: string;
  menuId: string;
}

export interface CreateMenuParams {
  restaurantId: string;
  data: MenuFormData;
}

export interface UpdateMenuParams extends CreateMenuParams {
  menuId: string;
}

export interface MenuDetails {
  id: string;
  title: LocalizedString;
  mealItems: MealItem[];
  availability?: {
    weekDays: number[];
    startTime: string;
    endTime: string;
  };
}

export interface MenuData {
  id: string;
  title: string;
}

export interface MenuFormModel {
  id?: string;
  title: LocalizedString;
}

export const toMenuFormModel = (formData: MenuFormData): MenuFormModel => {
  return {
    id: formData.id,
    title: formDataToLocalizedString(formData.titles),
  };
};

export const toMenuFormData = (model: MenuFormModel): MenuFormData => {
  return {
    id: model.id,
    titles: localizedStringToFormData(model.title),
  };
};
